// extracted by mini-css-extract-plugin
export default {"UserManagement":"styles_UserManagement__BRmBD","tableContainer":"styles_tableContainer__5O-NY"};